<template>
    <div class="hero-body is-paddingless" id="wrap-svg">
        <svg id="svg-scheme" preserveAspectRatio="xMinYMin meet">
            <g class="svg-pan-zoom_viewport">
                <seat v-for="(place, index) in places"
                      :place="place"
                      :lengthSeats="places.length"
                      :indexThisSeat="index"
                      v-bind:key="place.id">
                </seat>
            </g>
        </svg>
        <div class="control-zoom">
            <button class="control-zoom__button button is-rounded plus" @click="zoomPlus">
                      <span class="icon is-large">
                      <i class="mdi mdi-24px mdi-plus"></i>
                    </span>
            </button>
            <button class="control-zoom__button button is-rounded minus" @click="zoomMinus">
                    <span class="icon is-large">
                      <i class="mdi mdi-24px mdi-minus"></i>
                    </span>
            </button>
        </div>
        <legend-price/>
        <!--        <router-link class="button is-info is-rounded has-text-weight-bold button-back"-->
        <!--                     tag="a"-->
        <!--                     :to="'/sections'">-->
        <b-button type="is-info"
                  class="is-rounded has-text-weight-bold button-back"
                  @click="goToSectionList()"
                  v-if="hallPlan.length>1">
                 <span class="icon">
                  <i class="mdi mdi-24px mdi-undo"></i>
                </span>
            <span>К секциям</span>
        </b-button>
        <!--        </router-link>-->
    </div>

</template>

<script>
    import Seat from './Seat';
    import LegendPrice from './LegendPrice';

    import {svgMixin} from "../mixins/svgMixin";
    import {mapState} from "vuex";

    export default {
        name: "Section",
        mixins: [svgMixin],
        components: {
            'seat': Seat,
            LegendPrice
        },
        data() {
            return {
                sectionID: this.$route.params.section_id,
                selections: {},
                places: []
            }
        },
        computed: {
            ...mapState({
                hallPlan: state => state.hallPlan,
                performanceID: state => state.performanceID,
            }),
        },
        methods: {
            getSectionTickets() {
                window.api.getPerformanceTickets(this.performanceID, this.sectionID)
                    .then(response => {
                        this.places = response.data.body;
                        // console.log(response.data.body)
                        // this.$nextTick(function () {
                        // Send the event on a channel (hideLoader)
                        // eventBus.$emit('hideLoader', true);

                        // })
                    })
                    .catch(e => {
                        console.log(e);
                        this.$buefy.snackbar.open({
                            duration: 5000,
                            message: e.data.message,
                            type: 'is-danger',
                            position: 'is-bottom-left',
                            queue: false,
                        })
                        this.$router.push({name: 'Error'});
                    });
            },
            goToSectionList() {
                this.$events.fire('showLoader');
                setTimeout(() => {
                    this.$router.push({name: 'Sections'})
                }, 500);
            }
        },
        created() {
            // this.$store.dispatch({
            //     type: 'places/getPlacesSection',
            //     sectionID: this.sectionID,
            //     mode: 'sections'
            // });
            this.getSectionTickets();

        },
        mounted() {
            this.setHeaderSVG('svg-scheme');
        },
        events: {
            endRenderSeats() {
                this.initPanZoom('svg-scheme');
            }
        }


    }
</script>

<style scoped lang="scss">

    svg {
        width: 100%;
        // Анимация довольно спорная при pan
        /*.svg-pan-zoom_viewport {*/
        /*    transition: transform 0.2s ease-out;*/
        /*}*/
    }

    .hero {
        &-body {
            height: 100%;
            flex: 1;
            position: relative;
            align-items: normal !important;

            .button-back {
                position: absolute;
                left: 0;
                bottom: 0;
                text-transform: lowercase;
            }
        }
    }
</style>
